import { useQuery } from "@tanstack/react-query";
import { SystemSearchVersion } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
import i18n from "i18n";
export const fetchSearchVersionCheck = ({ queryKey }) => {
  const [
    ,
    /* queryName */
    { distribution, version }
  ] = queryKey;
  return defaultOnError(
    SystemSearchVersion.satisfiesVersion(distribution, version || void 0),
    i18n.t("use_search_version_check_notifications.fetch_failed_title", { ns: "common" })
  );
};
const useSearchVersionCheck = (distribution, version) => {
  const MAIN_KEY = "SearchVersionQuery";
  const queryKey = [MAIN_KEY, { distribution, version: version != null ? version : null }];
  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: (args) => defaultOnError(
      fetchSearchVersionCheck(args),
      i18n.t("use_search_version_check_notifications.fetch_failed_title", { ns: "common" })
    )
  });
  return {
    data,
    isLoading,
    error
  };
};
export default useSearchVersionCheck;
